var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCardBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1235,
    height: 632,
    viewBox: "0 0 1235 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M917.08 113.445C1052.56 33.7895 1234.21 0.269531 1234.21 0.269531V308.779V470.159V564.752C1234.21 564.752 1237.05 601.032 1218.84 615.721C1196.33 633.883 1165.81 631.54 1165.81 631.54H925.862H617.518H0.82959C0.82959 631.54 295.987 600.659 449.685 526.747C649.446 430.684 728.159 224.521 917.08 113.445Z",
    fill: "url(#paint0_linear_2511_8902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2511_8902",
    x1: 477.982,
    y1: 111.769,
    x2: 1142.25,
    y2: 730.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCardBackground);
export default __webpack_public_path__ + "static/media/upload_card_background.af00a1d147427de6ee64abbf75dda0d0.svg";
export { ForwardRef as ReactComponent };